module.exports = __webpack_public_path__ + "static/tecnica-feynman-f62e0d70a06c45203770759470dac0c4.jpg";